
 // billingReducers
 export const SET_BILLING_LOADER= 'SET_BILLING_LOADER';
 export const FETCH_BILLING_DATA= 'FETCH_BILLING_DATA';
 export const SET_BILLING_DATA= 'SET_BILLING_DATA';
 export const SET_BILLING_FETCH_SUCCESS= 'SET_BILLING_FETCH_SUCCESS';